import { createStore, combineReducers } from 'redux';
import reducers from '../reducers';
import {ip} from '../session'
export default function configureStore() {

  //let ip="18.223.119.58";

  window.localStorage.ch_domain="/huaxia_chorus";
  window.localStorage.ch_domain_name="huaxia_chorus";
  
  window.localStorage.ch_action_url="http://"+ip+"/song_action";
  //window.localStorage.ch_action_url="http://localhost:8080/song_action";

  if(!window.localStorage.getItem("ch_isLogin"))
  {
    window.localStorage.ch_isLogin="0";
  }
  if(!window.localStorage.getItem("ch_token"))
  {
      window.localStorage.ch_token="";
  }

  return createStore(
    combineReducers({
      ...reducers
    }),
    {}
  );
}
